import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { NgbAccordionModule, NgbButtonsModule, NgbCollapseModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PipesModule } from '../shared/pipes/pipes.module';

import { PublicComponent } from './public.component';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { BlogComponent } from './blog/blog.component';
import { ObrigadoComponent } from './obrigado/obrigado.component';
import { PdaComponent } from './pda/pda.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { VideoComponent } from './video/video.component';


const routes: Routes = [
  { path: '', component: PublicComponent },
  { path: 'enem', component: PublicComponent },
  { path: 'residencia-medica', component: PublicComponent },

  { path: 'editais', component: AnnouncementsComponent },
  // { path: 'app', loadChildren: () => import('./app/app.module').then(m => m.AppModule) },
  // { path: 'black-friday', loadChildren: () => import('./black-friday/black-friday.module').then(m => m.BlackFridayModule) },
  { path: 'blog', component: BlogComponent },
  { path: 'bonus', loadChildren: () => import('./bonus/bonus.module').then(m => m.BonusModule) },
  { path: 'obrigado', component: ObrigadoComponent },
  // { path: 'planilha', component: PdaComponent },
  { path: 'tutorial', component: PlaylistComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-use', component: TermsOfUseComponent },
  { path: 'video', component: VideoComponent }
];


@NgModule({
  declarations: [
    PublicComponent,
    AnnouncementsComponent,
    ObrigadoComponent,
    PdaComponent,
    PlaylistComponent,
    PrivacyPolicyComponent,
    TermsOfUseComponent,
    VideoComponent,
    BlogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    NgbAccordionModule,
    NgbTooltipModule,
    NgbCollapseModule,
    NgbButtonsModule,
    NgbDropdownModule,
    NgxMaskModule,
    InfiniteScrollModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class PublicModule { }
